import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  transform(value: Date | string, format?: string): string {
    if (!value) {
      return null;
    }

    const momentDate = moment(value, 'DD-MM-YYYY', true);

    if (momentDate.isValid()) {
      return momentDate.format(format ? format : 'D MMMM YYYY');
    } else {
      console.error('Invalid date format:', value);
      return null;
    }
  }
}
